var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.4434 11.8412C16.3679 11.1379 16.9623 10.0509 16.9623 8.83616C16.9623 6.72627 15.1792 5 13 5C10.8208 5 9.03774 6.72627 9.03774 8.83616C9.03774 10.0509 9.63208 11.1379 10.5566 11.8412C7.91509 12.8002 6 15.2937 6 18.1708C6 21.9431 20 21.9431 20 18.1708C20 15.2937 18.1509 12.8002 15.4434 11.8412Z","fill":"#C4C4C4","key":0}),React.createElement("circle",{"cx":"13","cy":"13","r":"12.5","stroke":"#C4C4C4","key":1})]);
}

User.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = User;

User.default = User;
